import React, { ReactNode } from 'react';

export const renderErrorDetails = (details: Record<string, unknown>): ReactNode => (
  <>
    {Object.entries(details).map(([k, v]) => {
      const lines = String(v)
        .split('\n')
        .map((s) => s.trim())
        .filter(Boolean);
      if (lines.length <= 1) {
        return (
          <div key={k}>
            {k}: {lines[0] ?? String(v)}
          </div>
        );
      }
      return (
        <div key={k}>
          <div>{k}:</div>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {lines.map((line, i) => (
              <li key={i}>{line}</li>
            ))}
          </ul>
        </div>
      );
    })}
  </>
);
